export const isGiveawayDeleted = giveaway => {
  return !!giveaway.deletedAt;
};